module.exports = __webpack_public_path__ + "img/length_to_underbust.0fac9a6f.png";